if (!customElements.get('custom-tabs')) {
  class CustomTabs extends HTMLElement {
    constructor() {
      super();
      this.bars = this.querySelectorAll('.custom-tabs__bar');
      this.tabs = this.querySelectorAll('.custom-tabs__tab');
      this.bars.forEach((bar, index) => {
        bar.addEventListener('click', () => {
          this.setActive(index);
        });
      });
    }

    closeAll() {
      this.bars.forEach(b => b.removeAttribute('data-active'));
      this.tabs.forEach(t => t.removeAttribute('data-active'));
    }

    setActive(index) {
      if (this.bars[index].hasAttribute('data-active')) {
        this.bars[index].removeAttribute('data-active');
        this.tabs[index].removeAttribute('data-active');
      } else {
        this.closeAll();
        this.bars[index].setAttribute('data-active', '');
        this.tabs[index].setAttribute('data-active', '');


        if (!this.hasAttribute('data-buy-box-infos')) {
          const barTop = this.bars[index].getBoundingClientRect().top + window.scrollY;

          // Desktop-only: account for sticky add-to-cart button height.
          const stickyOffset =
            window.matchMedia && window.matchMedia('(min-width: 900px)').matches
              ? (() => {
                const stickyButton = document.querySelector('.sticky-button');
                if (!stickyButton) return 0;
                const rect = stickyButton.getBoundingClientRect();
                return rect.height || 0;
              })()
              : 0;
          window.scrollTo({
            top: barTop - 70 - stickyOffset,
            behavior: 'auto'
          });
        }

      }
    }
  }
  customElements.define('custom-tabs', CustomTabs);
}
